<template>

		<md-card class="md-card-nav-tabs" v-if="renderComponent">
				<md-card-content>
						<md-tabs class="md-primary" md-alignment="left" md-dynamic-height :md-active-tab="this.activeTab">
						  <md-tab id="1" md-label="គណនីអ្នកគ្រប់គ្រងទាំងអស់" md-icon="supervisor_account">
								<md-table>
									<md-table-row>
										<md-table-head>ល.រ</md-table-head>
										<md-table-head>ឈ្មោះចូលគណនី</md-table-head>
										<md-table-head>ឈ្មោះ</md-table-head>
										<md-table-head>ទូរស័ព្ទ</md-table-head>
										<md-table-head>ប្រភេទគណនីយ</md-table-head>
										<md-table-head>ថ្ងៃបង្កើត</md-table-head>
										<md-table-head>សកម្មភាព</md-table-head>
									</md-table-row>

									<md-table-row v-for="(admin, index) in adminList">
										<md-table-cell>{{ index + 1 }}</md-table-cell>
										<md-table-cell>{{ admin.username }}</md-table-cell>
										<md-table-cell>{{ admin.name }}</md-table-cell>
										<md-table-cell>{{ admin.phone_number }}</md-table-cell>
										<md-table-cell>{{ config.getStatus(admin.account_type) }}</md-table-cell>
										<md-table-cell>{{ config.datelify(admin.created_date) }}</md-table-cell>
										<md-table-cell>
											<router-link :to="'/administrators/edit/' + admin.admin_id">
												<md-button class="md-just-icon md-simple md-primary">
													<md-icon>edit</md-icon>
													<md-tooltip md-direction="top">កែ</md-tooltip>
												</md-button>
											</router-link>
											<md-button class="md-just-icon md-simple md-danger" @click="showDeleteAction(admin.admin_id)">
												<md-icon>close</md-icon>
												<md-tooltip md-direction="top">លុប</md-tooltip>
											</md-button>
										</md-table-cell>
									</md-table-row>
								</md-table>
						  </md-tab>

						  <md-tab id="2" md-label="បង្កើតគណនីអ្នកគ្រប់គ្រងថ្មី" md-icon="create">
								<div class="md-layout">
									<div class="md-layout-item md-small-size-100 md-size-50">
										<md-field>
											<label>ឈ្មោះ</label>
											<md-input v-model="admin.name" type="text" required @keyup="checkValidation()"></md-input>
										</md-field>
									</div>
									<div class="md-layout-item md-small-size-100 md-size-50">
										<md-field>
											<label>លេខទូរស័ព្ទ</label>
											<md-input v-model="admin.phoneNumber" type="number" required @keyup="checkValidation()"></md-input>
										</md-field>
									</div>
									<div class="md-layout-item md-small-size-100 md-size-50">
										<md-field>
											<label>ឈ្មោះចូលគណនី</label>
											<md-input v-model="admin.username" type="text" required @keyup="checkValidation()"></md-input>
										</md-field>
									</div>
									<div class="md-layout-item md-small-size-100 md-size-50">
										<md-field>
											<label>ប្រភេទគណនី</label>
											<md-select placeholder="ប្រភេទគណនី" v-model="admin.account_type" @md-selected="checkValidation()">
												<md-option value="ad">អ្នកផ្តល់សេវាអតិថិជន</md-option>
												<md-option value="oa">អ្នកគ្រប់គ្រងទូទៅ</md-option>
												<md-option value="sa">អ្នកគ្រប់គ្រងជាន់ខ្ពស់</md-option>
											</md-select>
										</md-field>
									</div>
									<div class="md-layout-item md-small-size-100 md-size-100">
										<md-field>
											<label>ពាក្យសំងាត់</label>
											<md-input v-model="admin.password" type="password" required @keyup="checkValidation()"></md-input>
										</md-field>
									</div>
									<div class="md-layout-item md-small-size-100 md-size-100">
										<md-field>
											<label>បញ្ជាក់ពាក្យសំងាត់</label>
											<md-input v-model="admin.confirmPassword" type="password" required @keyup="checkValidation()"></md-input>
										</md-field>
									</div>

									<div class="md-layout-item md-size-100 text-right">
										<md-button :class="{'md-raised': true, 'md-primary': isValid}" @click="postAdmin()" :disabled="!isValid">បង្កើត</md-button>
									</div>
								</div>
						  </md-tab>
						</md-tabs>
						<md-dialog-confirm :md-active.sync="dialogActive" md-title="តើអ្នកពិតជាចង់លុបគណនីនេះមែនទេ ?" md-content="ដោយចុច OK នោះគណនីនេះនឹងត្រូវបានលុបជារៀងរហូត" md-confirm-text="OK" md-cancel-text="បោះបង់" @md-cancel="onCancel"
		   @md-confirm="onDelete" />
				</md-card-content>
			</md-card>
</template>

<script>
	export default {
		created() {
			this.getAdmin();
		},
		data() {
			return {
				activeTab: "1",
				dialogActive: false,
				deleteSelected: '',
				isValid: false,
				adminList: [],
				renderComponent: true,
				admin: {
					name: "",
					phoneNumber: "",
					account_type: "",
					username: "",
					password: "",
					confirmPassword: ""
				}
			}
		},
		methods: {
			getAdmin(offset = 0, replace = true) {
				this.$http.get(this.config.api + "/admin/admin/get/list/" + offset).then(data => {

					this.adminList = replace ? data.body.data : this.adminList.concat(data.body.data)
					this.activeTab = "1";
					this.forceRerender();

				})
			},
			loadMore() {
				this.getAdmin(this.adminList.length, false);
			},
			postAdmin() {
				let name = this.admin.name
				let phoneNumber = this.admin.phoneNumber
				let username = this.admin.username
				let password = this.admin.password
				let account_type = this.admin.account_type

				this.clear()
				this.checkValidation()

				this.$http.post(this.config.api + "/admin/admin/post", {
					username,
					name,
					password,
					phoneNumber,
					account_type
				}).then(res => {
					if (res.body.status == 'success') {
						this.tabName = 'first'
						this.$notification.notify({
							message: "គណនីយត្រូវបានបង្កើតដោយជោគជ័យ។",
							icon: 'done',
							type: 'success'
						})
						this.getAdmin();
					}
				})
			},
			showDeleteAction(id) {
				this.deleteSelected = id
				this.dialogActive = true
			},
			onDelete() {
				this.$http.post(this.config.api + "/admin/admin/delete", {
					admin_id: this.deleteSelected
				}, {
					headers: {
						"Content-Type": "application/json"
					}
				}).then(res => {
					if (res.body.status == 'success') {
						this.$notification.notify({
							message: "គណនីយត្រូវបានលុបដោយជោគជ័យ។",
							icon: 'done',
							type: 'success'
						})
						this.getAdmin();
						this.dialogActive = false
					}
				})
			},
			onCancel() {
				this.deleteSelected = ""
				this.dialogActive = false
			},
			checkValidation() {
				this.admin.username = this.config.validateUsername(this.admin.username);
				if (this.admin.name.length > 3 &&
					this.admin.phoneNumber.length > 8 &&
					this.admin.username.length > 3 &&
					this.config.validateUsername(this.admin.username) == this.admin.username &&
					this.admin.password.length > 6 &&
					this.admin.account_type.length > 0 &&
					this.admin.confirmPassword.length > 6 && this.admin.password == this.admin.confirmPassword) {
					this.isValid = true
				} else {
					this.isValid = false
				}
			},
			clear() {
				this.admin.name = ""
				this.admin.phoneNumber = ""
				this.admin.username = ""
				this.admin.password = ""
				this.admin.confirmPassword = ""
			},
			forceRerender() {
				// Remove my-component from the DOM
				this.renderComponent = false;

				this.$nextTick(() => {
					// Add the component back in
					this.renderComponent = true;
				});
			}
		}
	}
</script>



// WEBPACK FOOTER //
// src/pages/Administrators/View.vue